import React from "react";
import { images } from "../shared/images";

const Faq = () => {
	// showHideFAQ(position) {
	// 	this.faqs[position].active = !this.faqs[position].active;
	// },
	// const [openFaq, setOpenFaq] = useState({
	// 	id: 0,
	// 	open: true,
	// });
	// const [activeFaq, setActiveFaq] = useState(false);

	const faqs = [
		{
			id: 1,
			label: "What is Nitro NFT Whitelist?",
			content: (
				<p>
					Nitro NFT is process of shortlisting wallet addresses with priority
					access to an NFT collection before making it available to the general
					public. Please note: Following all the steps will just qualify you to
					be eligible to win a whitelist spot, it's not a gaurantee. Whitelist
					spot will be given after validating your enteries and activities.
				</p>
			),
			isActive: false,
		},
		{
			id: 2,
			label: "Why should I whitelist for Nitro NFT?",
			content: (
				<p>With Nitro NFT whitelisting, you will get an NFT at 0.05 ETH</p>
			),
			isActive: false,
		},
		{
			id: 3,
			label: "By when do I have to whitelist?",
			content: (
				<p>
					Whitelisting will start from 10, Feb'23 ( 10:00 AM UTC) and will be
					active till 6, Mar'23 (10:00 PM UTC). Whitelisting early is
					recommended since shortlisting will take place on a First Come, First
					Served (FCFS) basis.
				</p>
			),
			isActive: false,
		},
		{
			id: 4,
			label: "When will the whitelist process end?",
			content: (
				<p>
					It will end on 6 Mar, Feb'23 (10:00 PM UTC). While shortlisted WL
					users will be able to mint the NFT from 9 March onwards on Opensea.{" "}
				</p>
			),
			isActive: false,
		},
		{
			id: 5,
			label: "What is the timesheet for the Whitelist process",
			content: (
				<table>
					<tbody>
						<tr>
							<td>Start whitelist</td>
							<td>10 Feb</td>
						</tr>
						<tr>
							<td>Close Whitelist</td>
							<td>6 Mar</td>
						</tr>
						<tr>
							<td>Whitelist & Genesis Mint</td>
							<td>9 Mar - 17 Mar</td>
						</tr>
						{/* <tr>
							<td>Release second WL spot with pay and mint</td>
							<td>4 Mar-6 Mar</td>
						</tr> */}
						<tr>
							<td>Public Mint Starts</td>
							<td>18 Mar</td>
						</tr>
						{/* <tr>
							<td>Minting for whitelisters</td>
							<td>27 Feb</td>
						</tr>
						<tr>
							<td>Return money to non-WL</td>
							<td>27 Feb</td>
						</tr> */}
					</tbody>
				</table>
			),
			isActive: false,
		},
		{
			id: 6,
			label: "How to get a whitelist spot?",
			content: <p>Complete the whitelist process by doing all the fun tasks</p>,
		},
		{
			id: 7,
			label: "What is the selection process?",
			content: (
				<p>
					People who come first and complete all the optional and mandatory
					tasks of whitelist successfully will have high chance of getting a
					whitelist spot.
				</p>
			),
			isActive: false,
		},
		{
			id: 8,
			label:
				"If I don't pay 0.01 ETH USDT, is there any chance of getting whitelist spot?",
			content: (
				<p>
					You may get, chances are less. Paying 0.01 ETH is optional. However,
					people who pay will be given priority and have high chance of winning
					a WL spot
				</p>
			),
			isActive: false,
		},
		{
			id: 9,
			label: "Can I apply more whitelist spots?",
			content: (
				<p>
					Yes, You will have to pay 0.01 ETH x no. of WL spot you want to apply
					for. Pay in multiples of 0.01 ETH. Ex- if you want to apply for 3
					whitelist spots, 0.03 ETH in total. Any partial payment will lead to
					disqualification.
				</p>
			),
			isActive: false,
		},
		{
			id: 10,
			label: "How many whitelist spots are there in total?",
			content: <p>800</p>,
			isActive: false,
		},
		{
			id: 11,
			label:
				"Let's say I paid 0.01 ETH but I didn't get the WL spot, then when will I get my money back?",
			content: (
				<p>
					You will get it on 14th Mar in the same wallet address from which you
					have paid. Please note that you will get 0.01 ETH irrespective of
					market volatility and price. For further timeline requirements, please
					visit question 5.
				</p>
			),
			isActive: false,
		},
		{
			id: 12,
			label:
				"In case I win the whitelist spot, in how many days I have to pay?",
			content: (
				<p>
					If you belong to the first WL allowlist list, then you will be paying
					to mint your NFT between 9th March to 17th March. Please check our
					drop on opensea to know more -{" "}
					<a
						href="https://opensea.io/collection/nitrobotarmy/drop"
						target="_blank"
						rel="noreferrer"
						className="text-primary"
					>
						https://opensea.io/collection/nitrobotarmy/drop{" "}
					</a>
				</p>
			),
			isActive: false,
		},
		{
			id: 13,
			label:
				"In case, I don't pay within the mentioned timeline, what will happend to my spot and money?",
			content: (
				<p>
					You will loose your spot and and your spot will be given to the next
					eligible whitelisters in the second list. Your money will be returned.
				</p>
			),
			isActive: false,
		},
		{
			id: 14,
			label: "Where can I read more about Nitro Network?",
			content: (
				<p>
					Please visit our website :{" "}
					<a href="https://nitro.network/" target="_blank" rel="noreferrer">
						https://nitro.network/
					</a>
				</p>
			),
			isActive: false,
		},
		{
			id: 15,
			label:
				"I have performed all the tasks, what else can I do to increase my chance of getting a whitelist spot?",
			content: (
				<p>
					Refer the whitelist to your friends and onboard them. The more you
					refer, the more points your earn and get closer to winning a whitelist
					spot.
				</p>
			),
			isActive: false,
		},
		{
			id: 16,
			label:
				"In opensea drop whitelist, do I have to pay 0.04 ETH or 0.05 ETH? ",
			content: (
				<p>
					Due to standard process followed by Opensea Drop, you will pay 0.05
					ETH to mint your NFT. And the amount you paid for whitelist will be
					will be returned to you after allowlist mint for Genesis & whitelist
					ends on Opensea (within 5 working days). The amount will be in ETH and
					what you have paid, irrespective of ETH value. Hence, if you paid
					0.01ETH then you will receive 0.01 ETH.
				</p>
			),
			isActive: false,
		},
	];

	return (
		<div className="faq">
			<div className="faq__bg">
				<img src={images.faqHeading} alt="Faq heading" />
			</div>

			<div className="faq__box pos">
				{faqs.map((faq, index) => {
					return (
						<>
							<Question
								id={faq.id}
								keys={index}
								question={faq.label}
								answer={faq.content}
							/>
						</>
					);
				})}
			</div>
			{/* Old
				
					<div
							key={faq.id}
							// className={`faqs ${activeFaq ? "show" : ""}`}
							// className={`faqs ${
							// 	openFaq.id === index && openFaq.open ? "show" : ""
							// }`}
							className={`faqs ${
								openFaq.id === index ? (activeFaq ? "show" : "") : ""
							}`}
						>
							<div
								className="faq__question"
								// onClick={() => {
								// 	setOpenFaq({
								// 		id: index,
								// 		open: !openFaq.open,
								// 	});
								// 	console.log("Update it", index, openFaq.open);
								// }}
								onClick={() => handleClick(faq.id - 1)}
							>
								<p>{faq.label}</p>

								<p>
									<i className="fa-solid fa-caret-right"></i>
								</p>
							</div>

							<div className={`faq__answer `}>{faq.content}</div>
						</div>
				 */}

			{/* <div className="faqs"> */}

			{/* <div className="faq__question">
					<p>
						Refer the whitelist to your friends and onboard them. The more you
						refer, the more points your earn and get closer to winning a
						whitelist spot.
					</p>

					<p>
						<i className="fa-solid fa-caret-right"></i>
					</p>
				</div>

				<div className="faq__answer">
					<p>
						Refer the whitelist to your friends and onboard them. The more you
						refer, the more points your earn and get closer to winning a
						whitelist spot.
					</p>
				</div> */}
			{/* </div> */}

			{/* <div className="faqs">
				<div className="faq__question">
					<p>
						Refer the whitelist to your friends and onboard them. The more you
						refer, the more points your earn and get closer to winning a
						whitelist spot.
					</p>

					<p>
						<i className="fa-solid fa-caret-right"></i>
					</p>
				</div>

				<div className="faq__answer">
					<p>
						Refer the whitelist to your friends and onboard them. The more you
						refer, the more points your earn and get closer to winning a
						whitelist spot.
					</p>
				</div>
			</div> */}
		</div>
	);
};

export default Faq;

const Question = (props) => {
	const [isActive, setActive] = React.useState(false);
	const handleClick = (id) => {
		setActive(!isActive);
	};
	return (
		<div key={props.keys} className={isActive ? "faqs show" : "faqs"}>
			<div className="faq__question" onClick={() => handleClick(props.id)}>
				<p>{props.question}</p>

				<p>
					<i className="fa-solid fa-caret-right"></i>
				</p>
			</div>

			<div className={`faq__answer `}>{props.answer}</div>
		</div>
	);
};
